import { getAPIURL } from 'helper/helper';

const apiURL = getAPIURL();

const channelAPPConfig = {
	api: {
		PORTAL_DOMAIN: `${apiURL}/v1/identity/user-context?permissions=true`,
		RB_DOMAIN: `${apiURL}/reportbuilder/template/api`,
		RB_PREVIEW_DOMAIN: `${apiURL}/reportbuilder/query/api`,
		RB_CUSTOM_DATASET: `${apiURL}/reportbuilder/template/api/customDataset`,
		RB_SCHEDULE_DOMAIN: `${apiURL}/reportbuilder/schedule/api`,
		RB_DOWNLOAD_DOMAIN: `${apiURL}/reportbuilder/download/api`,
		CP_PROFILE_DOMAIN: `${apiURL}/channelperformance/profile`,
		CP_USER_DOMAIN: `${apiURL}/core-app-api`
	}
};

export default channelAPPConfig;
